import { render, staticRenderFns } from "./FarmsEdit.vue?vue&type=template&id=2d075cec&scoped=true"
import script from "./FarmsEdit.vue?vue&type=script&lang=js"
export * from "./FarmsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d075cec",
  null
  
)

export default component.exports